<template>
    <AuthStepBasicDialog :errorMessage="state.errorMessage" :successMessage="state.successMessage">




        <template #icon>
            <EmailIcon></EmailIcon>
        </template>



        <template #title>
            Verification link sent!
        </template>



        <template #description>
            <span class="opacity-60">We sent a password reset link to </span>
            <span class="weight-600">{{ state.email }}</span>
        </template>




        <template #form>
            <div class="text-14 weight-500 text-center">
                <span class="opacity-60">Didn't receive the link? </span>
                <span class="pointer text-primary" @click="resendVerificationLink"
                    :class="{ 'disabled-text': resendDisabled }">
                    Click to resend
                    <template v-if="countdown > 0">
                        ({{ countdown }}s)
                    </template>
                </span>
            </div>
        </template>





        <template #footer>
            <BackToChangeEmail />
        </template>




    </AuthStepBasicDialog>
</template>










<script setup>

import EmailIcon from '@/icons/ResetPassword/Email.vue';
import forgotPasswordEvents from '@/Events/ForgotPassword';
import { provide, ref, onUnmounted, onMounted, reactive } from 'vue';
import { ForgotPasswordService } from '@/api/services/ForgotPasswordService';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';
import BackToChangeEmail from '@/components/Auth/ForgotPassword/Actions/Back-To-Change-Email.vue';


const dialogVisible = ref(false);
provide('openDialog', dialogVisible);

const state = reactive({
    email: '',
    errorMessage: '',
    successMessage: '',
});








const countdown = ref(0);
const resendDisabled = ref(false);
let countdownInterval;

const startCountdown = () => {
    clearInterval(countdownInterval);
    countdown.value = 60;
    resendDisabled.value = true;
    countdownInterval = setInterval(() => {
        countdown.value--;
        if (countdown.value === 0) {
            clearInterval(countdownInterval);
            resendDisabled.value = false;
        }
    }, 1000);
};







const resendVerificationLink = async () => {
    if (resendDisabled.value) return;

    state.errorMessage = '';
    state.successMessage = '';

    try {
        const emailRequestResponse = await ForgotPasswordService.emailRequest(state.email);
        if (emailRequestResponse.success) {
            state.successMessage = 'Email sent successfully';
            startCountdown();
        } else {
            state.errorMessage = emailRequestResponse.message;
        }
    } catch (error) {
        state.errorMessage = error.friendly_message;
    }
};







const passwordResetLinkSent = async (sentEmail) => {
    openForgotPasswordDialog();
    state.email = sentEmail;
    startCountdown();
};







const openForgotPasswordDialog = () => {
    dialogVisible.value = true;
};

const closeForgotPasswordDialog = () => {
    dialogVisible.value = false;
};







// listen for events
onMounted(() => {
    forgotPasswordEvents.on('forgot-password-email-link-sent', passwordResetLinkSent);
});
// remove event listener and clear interval
onUnmounted(() => {
    forgotPasswordEvents.off('forgot-password-email-link-sent', passwordResetLinkSent);
    clearInterval(countdownInterval);
});

</script>